import * as actionTypes from '../actions/allActionList';

const initialState = {
  /* Auth Modal */
  showLoginModal: false,
  authTabValue: 0,

  /* Report Modal */
  showReportModal: false,
  reportType: '',
  idToReport: '',

  /* Classroom Created */
  classroomCreated: false,

  /* Classroom Global */
  activeClassroomCreatorId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOGIN_MODAL_STATE:
      return {
        ...state,
        showLoginModal: true,
      };
    case actionTypes.UNSET_LOGIN_MODAL_STATE:
      return {
        ...state,
        showLoginModal: false,
      };
    case actionTypes.SET_AUTH_TAB_VALUE:
      return {
        ...state,
        authTabValue: action.newValue,
      };
    case actionTypes.SET_REPORT_FORM_OPEN:
      return {
        ...state,
        showReportModal: true,
      };
    case actionTypes.UNSET_REPORT_FORM_OPEN:
      return {
        ...state,
        showReportModal: false,
      };
    case actionTypes.SET_REPORT_FORM_TYPE:
      return {
        ...state,
        reportType: action.reportType,
      };
    case actionTypes.SET_REPORT_FORM_ID:
      return {
        ...state,
        idToReport: action.id,
      };
    case actionTypes.SET_CLASSROOM_CREATOR_ID:
      return {
        ...state,
        activeClassroomCreatorId: action.id,
      };
    case actionTypes.SET_CLASSROOM_CREATED:
      return {
        ...state,
        classroomCreated: true,
      };
    case actionTypes.UNSET_CLASSROOM_CREATED:
      return {
        ...state,
        classroomCreated: false,
      };
    default:
      return state;
  }
};

export default reducer;
